import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextToiTeaser from '@contexts/toiTeaser'
import { TOITeaserLayoutContextType } from '@contexts/toiTeaser'
import { GradientProps } from '@widgets/Teaser/toi/types'
import { desktopCSS, tabletCSS, mobileCSS } from '@measures/responsive'

interface StyledGradientProps extends Pick<GradientProps, 'hasBulletpoints'> {
  alignment: TOITeaserLayoutContextType['mainTextAlignment']
}

const { TOITeaserLayoutContext } = contextToiTeaser

const StyledGradient = styled.div<StyledGradientProps>`
  ${({ alignment, hasBulletpoints }) => {
    const nonBulletBackgroundCSS = css`
      background-image: radial-gradient(
        ellipse 100% 100% at ${alignment.v} ${alignment.h},
        rgba(31, 31, 31, 0.75),
        rgba(31, 31, 31, 0.75) 60%,
        rgba(31, 31, 31, 0)
      );
    `

    const bulletBackgroundMobileCSS = css`
      background-image: linear-gradient(
        180deg,
        rgba(31, 31, 31, 0),
        rgba(31, 31, 31, 0.75) 51%,
        #1f1f1f 100%
      );
    `

    return css`
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: ${alignment.v === 'top' ? `calc(100% + 20px)` : `calc(100%)`};
      ${!hasBulletpoints && nonBulletBackgroundCSS}
      ${hasBulletpoints &&
      css`
        ${desktopCSS(nonBulletBackgroundCSS)}
        ${tabletCSS(nonBulletBackgroundCSS)}
        ${mobileCSS(bulletBackgroundMobileCSS)}
      `}
    `
  }};
`

const Gradient: FunctionComponent<GradientProps> = ({ hasBulletpoints }) => {
  const { mainTextAlignment } = useContext(TOITeaserLayoutContext)
  return (
    <StyledGradient
      alignment={mainTextAlignment}
      hasBulletpoints={hasBulletpoints}
    />
  )
}

export default Gradient
